import { z } from "zod";

/**
 * PRTL-1392: Zod 4 probes whether eval is allowed (`new Function("")`) the
 * first time it builds an object schema, to decide on its JIT fast path. Under
 * the strict CSP (no 'unsafe-eval') that probe is refused and logged as a
 * violation on every page load. `jitless` skips the probe and the JIT; the web
 * app only parses small payloads, so the fast path is not missed.
 *
 * Must run before any schema is built — index.tsx imports this first. Imports
 * are not auto-sorted today; if oxfmt's sortImports is turned on (PRTL-1489),
 * pin this import first so the sorter can't move it.
 */
z.config({ jitless: true });
